import React from "react";
import { Provider } from "react-redux";

import { PersistGate } from "redux-persist/integration/react";
import portalStore, { persistor } from "./store/index";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import langEN from "@locales/en.json";
import langES from "@locales/es.json";
import langAR from "@locales/ar.json";
import langCA from "@locales/ca.json";
import langCH from "@locales/ch.json";
import langMN from "@locales/mn.json";
import langPL from "@locales/pl.json";
import langRS from "@locales/rs.json";
import langUR from "@locales/ur.json";
import langKR from "@locales/kr.json";
import RootLayout from "./components/RootLayout/RootLayout";
import AuthPageRoutes from "./pages/Auth/authpage.routes";
import LandingPageRoutes from "./pages/Landing/landingpage.routes";
import MemberPageRoutes from "./pages/Landing/member.routes";
import AppointmentPageRoutes from "./pages/Appointment/appointmentspage.routes";

const resources = {
  en: {
    translation: langEN,
  },
  es: {
    translation: langES,
  },
  ar: {
    translation: langAR,
  },
  ca: {
    translation: langCA,
  },
  ch: {
    translation: langCH,
  },
  mn: {
    translation: langMN,
  },
  pl: {
    translation: langPL,
  },
  rs: {
    translation: langRS,
  },
  ur: {
    translation: langUR,
  },
  kr: {
    translation: langKR,
  },
};

i18n.use(initReactI18next).init({
  resources: resources,
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    children: [
      AuthPageRoutes,
      LandingPageRoutes,
      AppointmentPageRoutes,
      MemberPageRoutes,
    ],
  },
]);
const MemberPortal = () => {
  return (
    <>
      <div data-testid="member-portal"></div>
      <Provider store={portalStore}>
        <PersistGate loading={null} persistor={persistor}>
          <RouterProvider router={router} />
        </PersistGate>
      </Provider>
    </>
  );
};

export default MemberPortal;
